var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000",
    fillRule: "evenodd",
    clipPath: "url(#a)",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M.502 2.788a1.714 1.714 0 0 1 1.212-.502.571.571 0 0 1 0 1.143.571.571 0 0 0-.571.571v10.286a.572.572 0 0 0 .571.571h12.572a.572.572 0 0 0 .571-.571V4a.572.572 0 0 0-.571-.571H12a.571.571 0 0 1 0-1.143h2.286A1.714 1.714 0 0 1 16 4v10.286A1.714 1.714 0 0 1 14.286 16H1.714A1.714 1.714 0 0 1 0 14.286V4c0-.455.18-.89.502-1.212Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 7.429c0-.316.256-.572.571-.572H15.43a.571.571 0 1 1 0 1.143H.57A.571.571 0 0 1 0 7.429ZM4 0c.316 0 .571.256.571.571v4.572a.571.571 0 0 1-1.142 0V.57C3.429.256 3.684 0 4 0ZM12 0c.316 0 .571.256.571.571v4.572a.571.571 0 1 1-1.142 0V.57c0-.315.255-.571.571-.571Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.429 2.857c0-.315.255-.571.571-.571h5.714a.571.571 0 0 1 0 1.143H4a.571.571 0 0 1-.571-.572Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h16v16H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.0175c2c3bcafab52ce6b72cbab393fe0.svg";
export { ForwardRef as ReactComponent };